/**
 * Оформление карточек раздела «Управление».
 *
 * Вынесено в один модуль намеренно. Раньше каждая карточка объявляла свой
 * набор классов по месту, и они разошлись: у трёх было скругление 24 px и
 * лёгкая тень, у двух — 16 px и многослойная, а заголовки шли то нативным
 * <h2>, то стилизованным. На одном экране это видно сразу.
 */
export const ADMIN_PANEL =
  "flex flex-col gap-3.5 rounded-2xl border border-border bg-card p-6 shadow-md transition-shadow hover:shadow-lg";

export const ADMIN_PANEL_TITLE =
  "text-[18px] font-semibold tracking-[-0.019em] text-heading";

export const ADMIN_SUBTITLE = "text-sm font-semibold text-heading";

/** Подпись под заголовком карточки: зачем она и что делает. */
export const ADMIN_HINT = "text-[13px] leading-relaxed text-muted-foreground";
